import { SchemaUtil } from '../utils/schema.util';
import { ColumnMapVisitor } from './columnMap.visitor';
import { OutputPlainObject } from '../plainObjects/output.plainObject';

export class OutputVisitor extends ColumnMapVisitor {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitInputDefinition(inputDefinitionContext: any): void {
        (this.transformation as OutputPlainObject).columns = SchemaUtil.getSchemaFromInputOutputDefinition(inputDefinitionContext);
    }
}
